<template>
  <div class="login-modal-inner">
    <!-- Branded Header -->
    <div class="login-brand-header">
      <img src="../../icons/Logo.svg" alt="Renants" class="login-brand-logo" />
      <p class="login-brand-tagline">Your local community marketplace</p>
    </div>

    <div class="forgot-box login-form-body">
    <!-- Title -->
    <h2 class="title">Reset Password</h2>
    <p class="subtitle">Enter your email to receive a reset OTP.</p>

    <!-- Email -->
    <div class="group">
      <label>Email</label>
      <input type="email" v-model="email" placeholder="Enter email" />
    </div>
    <!-- OTP Input (shown only after Send OTP) -->
<div class="group" v-if="showOtpInput">
  <label>Enter OTP</label>
  <input type="text" v-model="otp" placeholder="Enter OTP" />
</div>

<!-- New Password -->
<div class="group password-wrapper" v-if="showPasswordInputs">
  <label>New Password</label>
  <input
    :type="showPassword ? 'text' : 'password'"
    v-model="password"
    placeholder="Enter Password"
  />
  <span class="toggle-password" @click="togglePassword">
    <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
  </span>
</div>

<!-- Confirm Password -->
<div class="group password-wrapper" v-if="showPasswordInputs">
  <label>Confirm New Password</label>
  <input
    :type="showConfirmPassword ? 'text' : 'password'"
    v-model="confirmPassword"
    placeholder="Re Enter Password"
  />
  <span class="toggle-password" @click="toggleConfirmPassword">
    <i :class="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
  </span>
</div>


<!-- Button -->
<button
  class="btn btn-primary w-100"
  :disabled="loading"
  @click="handleSubmit"
>
  <span v-if="!showOtpInput">Send OTP</span>
  <span v-else-if="showOtpInput && !showPasswordInputs">Verify OTP</span>
  <span v-else>Reset Password</span>

  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
</button>

    <!-- Footer -->
    <p class="footer" @click="$emit('switchMode', 'login')">
      Back to Login?
      <span class="link">Sign In</span>
    </p>
    </div><!-- end forgot-box -->
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue-sonner";
import { UAParser } from "ua-parser-js";
import { getRecaptchaToken } from "@/utils/recaptcha";
export default {
  emits: ["switchMode"],

  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      otp: "",
      showOtpInput: false,
      showPasswordInputs: false,   // ✅ Added for step 3
      loading: false,
      currentUserId: null,
        showPassword: false,
      showConfirmPassword: false
    };
  },
mounted(){
this.trackVisitor();
this.loadGoogleAnalytics();
},
  methods: {
    async  trackVisitor() {
  const parser = new UAParser();
  const browserInfo = parser.getResult();

  const visitData = {
    timestamp: new Date().toISOString(),
    browser: browserInfo.browser.name,
    browserVersion: browserInfo.browser.version,
    os: browserInfo.os.name,
    osVersion: browserInfo.os.version,
    device: browserInfo.device.type || "Desktop",
    pageName: "Reset Page",
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    const { ip } = await response.json();
    visitData.ip = ip;

    await fetch("/api/visitors", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(visitData),
    });
  } catch (error) {
    console.error("Error tracking visitor:", error);
  }
},

 loadGoogleAnalytics() {
  const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!gaId) return Promise.resolve();
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  return new Promise((resolve, reject) => {
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = (...args) => window.dataLayer.push(args);
      window.gtag("js", new Date());
      window.gtag("config", gaId);
      resolve();
    };

    script.onerror = () => {
      console.error("Failed to load Google Analytics.");
      reject(new Error("GA script load failed"));
    };
  });
},
       togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async handleSubmit() {
      // Guard as well as :disabled — a fast double-click can land two events
      // before Vue has re-rendered the button as disabled.
      if (this.loading) return;
      this.loading = true;

      if (!this.showOtpInput) {
        if (!this.email) {
          toast.error("Email required.");
          this.loading = false;
          return;
        }

        try {
          // Check email exists
          const checkResponse = await axios.post("/api/getoneusers", {
            email: this.email,
          });

          if (!checkResponse.data || checkResponse.data.length === 0) {
            toast.error("Oops! That email ID doesn't exist.");
            this.loading = false;
            return;
          }

          this.currentUserId = checkResponse.data[0].userID;

          // Send OTP
          const recaptchaToken = await getRecaptchaToken('otp_send');
          const otpResponse = await axios.post("/api/sendotp", {
            email: this.email,
            recaptchaToken,
          });

          if (otpResponse.status === 200) {
            this.showOtpInput = true;
            toast.success("OTP sent to your email.");
          } else {
            toast.error("Failed to send OTP.");
          }
        } catch (err) {
          console.error(err);
          toast.error("Error occurred while sending OTP.");
        } finally {
          this.loading = false;
        }

        return;
      }

      if (this.showOtpInput && !this.showPasswordInputs) {
        if (!this.otp) {
          toast.error("OTP is required.");
          this.loading = false;
          return;
        }

        try {
          const verify = await axios.post("/api/verifyotp", {
            email: this.email,
            otp: this.otp,
          });

          if (
            !verify.data ||
            verify.data.message?.toLowerCase().includes("invalid") ||
            verify.data.message?.toLowerCase().includes("failed")
          ) {
            toast.error("Invalid OTP. Try again.");
            this.loading = false;
            return;
          }

          // OTP Verified → now show password fields
          this.showPasswordInputs = true;    // ✅ show password inputs now
          toast.success("OTP verified! Enter new password.");
        } catch (err) {
          console.error(err);
          toast.error("Error verifying OTP.");
        } finally {
          this.loading = false;
        }

        return;
      }

      if (this.showPasswordInputs) {
        if (!this.password || !this.confirmPassword) {
          toast.error("Both password fields are required.");
          this.loading = false;
          return;
        }

        if (this.password !== this.confirmPassword) {
          toast.error("Passwords do not match.");
          this.loading = false;
          return;
        }

        try {
          await axios.put("/api/updateoneuser", {
            userID: this.currentUserId,
            password: this.confirmPassword,
          });

          toast.success("Password reset successfully!");
          this.$emit("switchMode", "login");
        } catch (err) {
          console.error(err);
          toast.error("Failed to reset password.");
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* ── Brand Header ── */
.login-brand-header {
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  border-radius: 14px 14px 0 0;
  padding: 22px 24px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.login-brand-logo {
  height: 32px;
  filter: brightness(0) invert(1);
}
.login-brand-tagline {
  color: rgba(255,255,255,0.75);
  font-size: 12px;
  font-family: var(--font-primary);
  margin: 0;
}
.login-form-body {
  padding: 24px 24px 20px;
}

.forgot-box {
  width: 100%;
}
.title {
  font-size: 22px;
  font-weight: 600;
}
.subtitle {
  font-size: 14px;
  color: #666;
}

.group label {

  color: #212529;

}

input {
  width: 100%;
  height: 42px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.btn {
  height: 42px;
  margin-top: 10px;
  border-radius: 8px;
}
.error {
  color: red;
  margin-top: 10px;
}
.success {
  color: green;
  margin-top: 10px;
}
.footer {
  text-align: center;
  margin:0;
}
.link {
  color: #0056ff;
  cursor: pointer;
  font-weight: 600;
}
.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 40px;
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-0%);
  cursor: pointer;
  color: #6b7280;
  font-size: 18px;
}

</style>
